/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Posts_Author_ColInputs */

const en_admin_posts_author_col = /** @type {(inputs: Admin_Posts_Author_ColInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Author`)
};

const zh_admin_posts_author_col = /** @type {(inputs: Admin_Posts_Author_ColInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`作者`)
};

/**
* | output |
* | --- |
* | "Author" |
*
* @param {Admin_Posts_Author_ColInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_posts_author_col = /** @type {((inputs?: Admin_Posts_Author_ColInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Posts_Author_ColInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_posts_author_col(inputs)
	return zh_admin_posts_author_col(inputs)
});
export { admin_posts_author_col as "admin.posts.author_col" }